<template>
  <el-card v-loading="loading">
    <!-- /* ---------------------------------- 表单查询 ---------------------------------- */ -->
    <el-row>
      <el-form v-bind="formProps.form" :rules="{}">
        <el-form-item prop="bankAccount" align="center" :label="$t('withdrawBank.label.bankAccount')">
          <el-input v-model="form.bankAccount" />
        </el-form-item>
        <!-- <el-form-item prop="bankBranch" align="center" :label="$t('withdrawBank.label.bankBranch')">
          <el-input v-model="form.bankBranch" />
        </el-form-item> -->
        <el-form-item prop="bankName" align="center" :label="$t('withdrawBank.label.bankName')">
          <el-input v-model="form.bankName" />
        </el-form-item>
        <el-form-item prop="bankNo" align="center" :label="$t('withdrawBank.label.bankNo')">
          <el-input v-model="form.bankNo" />
        </el-form-item>
        <el-form-item prop="createBy" align="center" :label="$t('withdrawBank.label.createBy')">
          <el-input v-model="form.createBy" />
        </el-form-item>
        <el-form-item prop="createTime" align="center" :label="$t('withdrawBank.label.createTime')">
          <el-date-picker v-model="form.createTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>

        <el-form-item prop="merchatNo" align="center" :label="$t('withdrawBank.label.merchatNo')">
          <el-input v-model="form.merchatNo" />
        </el-form-item>
        <el-form-item prop="updateBy" align="center" :label="$t('withdrawBank.label.updateBy')">
          <el-input v-model="form.updateBy" />
        </el-form-item>
        <el-form-item prop="updateTime" align="center" :label="$t('withdrawBank.label.updateTime')">
          <el-date-picker v-model="form.updateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>

        <el-form-item> 
          <el-button size="mini" type="success" @click="handleEmpty()">{{
            $t('btns.empty')
            }}</el-button>
          <el-button size="mini" type="primary" @click="handleSearch()">{{
            $t('btns.search')
            }}</el-button>
          <el-button size="mini" type="primary" v-if="userType === 2 || permission.indexOf(`add:withdrawBank`) > -1"
            @click="handleOpen()">{{
            $t('btns.add') }}</el-button>
          <el-button size="mini" type="primary"
            v-if="false && tableList.length && permission.indexOf(`export:withdrawBank`) > -1"
            @click="handleExport()">{{ $t('btns.export') }}</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <!-- /* ---------------------------------- 表格展示 ---------------------------------- */ -->
    <el-row>
      <el-table :data="tableList" :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ textAlign: 'center' }"
        stripe>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column width="150px" prop="merchatNo" align="center" :label="$t('withdrawBank.label.merchatNo')" />
        <el-table-column width="120px" prop="bankName" align="center" :label="$t('withdrawBank.label.bankName')" />
        <el-table-column width="120px" prop="bankNo" align="center" :label="$t('withdrawBank.label.bankNo')" />
        <el-table-column width="180px" prop="bankAccount" align="center"
          :label="$t('withdrawBank.label.bankAccount')" />
        <el-table-column width="100px" prop="id" align="center" :label="$t('withdrawBank.label.id')" />
        <el-table-column width="200px" prop="createTime" align="center" :label="$t('withdrawBank.label.createTime')">
          <template slot-scope="{ row }">
            {{ row.createTime | asDayjs }}
          </template>
        </el-table-column>
        <el-table-column width="200px" prop="updateTime" align="center" :label="$t('withdrawBank.label.updateTime')">
          <template slot-scope="{ row }">
            {{ row.updateTime | asDayjs }}
          </template>
        </el-table-column>
        <el-table-column width="120px" prop="updateBy" align="center" :label="$t('withdrawBank.label.updateBy')" />
        <el-table-column width="200px" prop="action" align="center" :label="$t('withdrawBank.label.action')">
          <template slot-scope="{ row }">
            <el-popconfirm :ref="`popover-${row.id}`" :key="row.id" :title="$t('orders.tip.danger')"
              @confirm="handleDelete(row)">
              <el-button slot="reference" v-if="tableList.length && permission.indexOf(`delete:withdrawBank`) > -1"
                size="mini" type="danger">
                {{ $t('btns.del') }}
              </el-button>
            </el-popconfirm>
            <!-- @NOTE 暂时注释编辑功能 -->
            <!-- <el-button
              @click="handleOpen(row)"
              v-if="tableList.length && permission.indexOf(`update:withdrawBank`) > -1"
              size="mini"
              type="primary"
            >
              {{ $t('btns.editor') }}
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!-- /* ---------------------------------- 分页区域 ---------------------------------- */ -->
    <v-pagination v-model="pagination" :total="tableData.rows" @update="getTableData" />

    <!-- /* ----------------------------------- 编辑 ----------------------------------- */ -->
    <el-dialog v-loading="loading" :title="$t(`withdrawBank.title.${isAdd ? 'add' : 'update'}`)" :visible.sync="dialogVisible" width="30%">
      <el-row>
        <el-form :model="form1" v-bind="formProps.form1">
          <el-form-item prop="bankAccount" align="center" :label="$t('withdrawBank.label.bankAccount')">
            <el-input v-model="form1.bankAccount" />
          </el-form-item>
          <el-form-item prop="bankBranch" align="center" :label="$t('withdrawBank.label.bankBranch')">
            <el-input v-model="form1.bankBranch" />
          </el-form-item>
          <el-form-item prop="bankName" align="center" :label="$t('withdrawBank.label.bankName')">
            <el-input v-model="form1.bankName" />
          </el-form-item>
          <el-form-item prop="bankNo" align="center" :label="$t('withdrawBank.label.bankNo')">
            <el-input v-model="form1.bankNo" />
          </el-form-item>

          <el-form-item prop="merchatNo" align="left" :label="$t('withdrawBank.label.merchatNo')">
            <el-input v-model="form1.merchatNo"  />
          </el-form-item>
          <el-form-item :label="$t('device.bankCode')" prop="bankCode">
            <el-select v-model="form1.bankCode" filterable clearable>
              <el-option v-for="item,index in bankTransferCodes" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="kaptchaCode" align="center" :label="$t('merchantdeposit.label.googleDynamicCaptcha')">
            <el-input v-model.trim="form1.kaptchaCode" />
          </el-form-item>
        </el-form>
      </el-row>

      <el-row slot="footer">
        <el-button @click="dialogVisible = false">{{ $t('btns.cancel') }}</el-button>
        <el-button type="primary" @click="handleEditor()">{{ $t('btns.confirm') }}</el-button>
      </el-row>
    </el-dialog>
  </el-card>
</template>

<script>
  import withdrawBankApi from '@/api/withdrawBank';
  import ordersApi from '@/api/orders';
  import { debounce } from 'lodash';
  import { isSymbol, minLenSymbol } from '@/utils/validate';
  import { mapGetters, mapState } from 'vuex';
  import base from "@/mixin/base.js"
  export default {
    mixins: [base],
    name: 'withdrawBank',
    data() {
      return {
        loading: false,
        dialogVisible: false,
        isAdd: true,
        form: {
          bankAccount: '',
          bankBranch: '',
          bankName: '',
          bankNo: '',
          createBy: '',
          createTime: '',
          merchatNo: '',
          updateBy: '',
          updateTime: ''
        },
        form1: {
          bankAccount: '',
          bankBranch: '',
          bankName: '',
          bankNo: '',
          id: '',
          merchatNo: '',
          bankCode: '',
          kaptchaCode: '',
        },
        pagination: {
          no: 1,
          size: this.$defaultPaginationSize
        },
        tableData: {},
        bankTransferCodes: [],
      };
    },
    computed: {
      ...mapState({
        userType: ({ user }) => user.info.userType,
        userName: ({ user }) => user.info.userName
      }),
      ...mapGetters(['permission']),
      tableList() {
        return this.tableData.list || [];
      }
    },
    created() {
      this.init();
      this.getBankCode();
    },
    mounted() {
      this.getTableData();
    },
    methods: {
      init() {
        this.handleSearch = debounce(this.getTableData, 300);
        this.handleDelete = debounce(this._handleDelete, 300);
        this.handleEditor = debounce(this._handleEditor, 300);
        this.types = this.$t('wallet.types');
        this.formProps = {
          form: {
            ref: 'form',
            'label-width': 'auto',
            inline: true,
            size: 'small',
            rules: {}
          },
          form1: {
            ref: 'form',
            'label-width': 'auto',
            inline: false,
            size: 'small',
            rules: {
              bankAccount: {
                required: true,
                message: this.$t('withdrawBank.rules.bankAccount'),
                trigger: 'blur'
              },

              bankName: {
                required: true,
                message: this.$t('withdrawBank.rules.bankName'),
                trigger: 'blur'
              },
              bankNo: [
                {
                  required: true,
                  message: this.$t('withdrawBank.rules.bankNo.required'),
                  trigger: 'blur'
                },
                {
                  validator: (rules, value, cb) => {
                    if (!isSymbol(value)) {
                      cb(new Error(this.$t('withdrawBank.rules.bankNo.symboltype')));
                    } else if (!minLenSymbol(5, value)) {
                      cb(new Error(this.$t('withdrawBank.rules.bankNo.min')));
                    } else {
                      cb();
                    }
                  },
                  trigger: 'blur'
                }
              ],
              merchatNo: {
                required: true,
                message: this.$t('withdrawBank.rules.merchatNo'),
                trigger: 'blur'
              },
              bankCode:[
                {
                  required: true,
                  message: this.$t('withdrawBank.rules.bankCode'),
                  trigger: 'change'
                }
              ],
               kaptchaCode: {
                required: true,
                message: this.$t('merchantdeposit.rules.googleDynamicCaptcha.required'),
                trigger: 'blur'
              },

            }
          }
        };
      },

      /* ---------------------------------- 格式化数据 --------------------------------- */
      formatParams() {
        return {
          ...Object.keys(this.form).reduce((acc, key) => {
            if (this.form[key] === 0 || this.form[key]) {
              acc[key] = this.form[key];
            }
            return acc;
          }, {})
        };
      },
  
      /* ---------------------------------- 获取数据 ---------------------------------- */
      async getTableData() {
        this.loading = true;
        const { data } = await withdrawBankApi.getPage({
          data: this.formatParams(),
          params: this.pagination
        });
        if (data.code === 200) {
          this.tableData = data.data;
          this.loading = false;
        } else {
          this.$message.error(data.msg);
          this.loading = false;
        }
      },

      /* --------------------------------- 事件驱动函数 --------------------------------- */
      handleEmpty() {
        this.form = {
          bankAccount: '',
          bankBranch: '',
          bankName: '',
          bankNo: '',
          createBy: '',
          createTime: '',
          id: '',
          merchatNo: '',
          updateBy: '',
          updateTime: ''
        };
        try {
          this.resetPagination();
        } catch (error) {}
      },

      handleEmpty1() {
        this.form1 = {
          bankAccount: '',
          bankBranch: '',
          bankName: '',
          bankNo: '',
          id: '',
          merchatNo: this.userType !== 0 ? this.userName : '',
          bankCode: '',
          kaptchaCode: '',
        };
      },

      handleOpen(row) {
        if (row) {
          this.isAdd = false;
          const { bankAccount, bankBranch, bankName, bankNo, id, merchatNo, bankCode} = row;
          this.form1 = {
            bankAccount,
            bankBranch,
            bankName,
            bankNo,
            id,
            merchatNo,
            bankCode
          };
        } else {
          this.isAdd = true;

          this.handleEmpty1();
        }
        if (this.userType === 2) {
          this.form1.merchatNo = this.userName;
        }
        this.dialogVisible = true;
      },

      _handleEditor() {
        const params = Object.keys(this.form1).reduce((acc, key) => {
          if (this.form1[key] === 0 || this.form1[key]) {
            acc[key] = this.form1[key];
          }
          return acc;
        }, {});
        this.isAdd ? this.handleAdd(params) : this.handleUpdate(params);
      },
      async _handleDelete({ id, merchatNo, bankNo }) {
        const params = {
          id,
          merchatNo,
          bankNo
        };
        const { data } = await withdrawBankApi.doDel(params);
        if (data && data.code === 200) {
          this.$message.success(this.$t('status.success'));
          this.getTableData();
        } else {
          this.$message.error(data.msg);
        }
      },

      async handleExport() {
        const { data } = await withdrawBankApi.doExport(this.formatParams());
        if (data) {
          const BLOB = data;
          const fileReader = new FileReader();
          fileReader.readAsDataURL(BLOB);
          fileReader.onload = (event) => {
            // 处理load事件。该事件在读取操作完成时触发
            // 新建个下载的a标签，完成后移除。
            let a = document.createElement('a');
            a.download = `数据报表${Number(new Date())}.xlsx`;
            a.href = event.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        } else {
          this.$message.error(this.$t('status.error'));
        }
      },

      async handleAdd(params) {
        this.loading = true;
        const { data } = await withdrawBankApi.doAdd(params);
        if (data && data.code === 200) {
          if(data.msg =='成功') {
            this.editorSuccess();
          }
          this.loading =false;
          this.dialogVisible = false;
        } else {
          this.$message.error(data.msg);
          this.loading =false;
        }
      },

      async handleUpdate(params) {
        const { data } = await withdrawBankApi.doUpdate(params);
        if (data && data.code === 200) {
          this.editorSuccess();
          this.dialogVisible = false;
        } else {
          this.$message.error(data.msg);
        }
      },
      editorSuccess() {
        this.$message.success(this.$t('status.success'));
        this.getTableData();
        this.dialogVisible = false;
        this.handleEmpty1();
      },
      async getBankCode() {
        const { data: { data: res } } = await withdrawBankApi.getBankCodeList();
        const arr = res.map(code => ({ label: code, value: code }));
        this.bankTransferCodes = [...arr, {label: 'USDT', value: 'USDT'}]
      },

    }
  };
</script>

<style lang="scss" scoped>
/deep/ .el-table__header,
/deep/ .el-table__body{
  width:100% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/withdrawBank/index.vue